import {Answer} from "../types/types";
import {useContext, useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {AppContext} from "../context/appContext";

type Props = {
	value?: Answer | null,
	onChange: (game: Answer | null) => void,
	filteredKeys: string[],
	onSubmit: Function
	disabled: boolean
}

export default function AnswerSearch ({
	value,
	onChange,
	filteredKeys,
	onSubmit,
	disabled,
} : Props) {
	const [inputValue, setInputValue] = useState('')
	const [showOptions, setShowOptions] = useState(false)
	const inputRef = useRef<HTMLInputElement>(null)
	const app = useContext(AppContext)
	const {answers} = app

	useEffect(() => {
		if (value) {
			setShowOptions(false)
			setInputValue(value.name)
		} else {
			setInputValue('')
		}
	}, [value])

	useEffect(() => {
		if (inputRef.current) {
			// Shitty non-mobile detect
			if (window.innerWidth > 1000) {
				inputRef.current.focus()
			}
		}
	}, [inputRef.current])

	function onChangeInput (e: any) {
		setInputValue(e.target.value)
		if (e.target.value) {
			setShowOptions(true)
		} else {
			setShowOptions(false)
		}
	}

	function clearSearch () {
		setInputValue('')
		onChange(null)
		setShowOptions(false)
	}

	function onKeyDown (e: any) {
		if (e.keyCode === 27) {
			clearSearch()
			return
		}
		if (e.keyCode === 38) {
			e.preventDefault()
		} else if (e.keyCode === 40) {
			e.preventDefault()
		} else if (e.keyCode === 13) {
			e.preventDefault()

			if (!showOptions && value) {
				onSubmit()
				return
			}

			if (options.length >= 1) {
				onChange(options[0])
			}
		}
	}

	let searchPieces = inputValue.trim().split(/\s+/).map(x => x.toLowerCase())
	let options = answers
	.filter((x) => {
		return filteredKeys.findIndex(key => key === x.key) === -1
	})
	.filter((x) => {
		const searchingIn = x.name.toLowerCase()
		for (let i = 0; i < searchPieces.length; i++) {
			const piece = searchPieces[i]
			if (searchingIn.indexOf(piece) === -1) {
				return false
			}
		}
		return true
	}).sort((a, b) => {
		return a.name > b.name ? 1 : -1
	})

	if (options.length > 20) {
		options = options.slice(0, 20)
	}

	return <AnswerSearchContainer>
		<OptionsContainer visible={showOptions}>
			{options.length === 0 && <EmptyMessage>Nothing found.</EmptyMessage>}
			{options.map((o) => {
				return <Option key={o.key} onClick={() => {
					onChange(o)
				}}>
					{o.name}
					{o.meta && <OptionMeta>({o.meta})</OptionMeta>}
				</Option>
			})}
		</OptionsContainer>
		<InputContainer>
			<svg style={{marginLeft: '5px'}}  xmlns="http://www.w3.org/2000/svg" width="18" height="18"
					 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
					 strokeLinejoin="round">
				<circle cx="11" cy="11" r="8"></circle>
				<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
				</svg>
			<SearchInput ref={inputRef} placeholder={app.searchPlaceHolder} value={inputValue} onChange={onChangeInput} onKeyDown={onKeyDown} />
			<svg style={{cursor: 'pointer'}} onClick={clearSearch} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
		</InputContainer>
	</AnswerSearchContainer>
}
const height = 40;
const AnswerSearchContainer = styled.div`
	position: relative;
	height: ${height}px;
	font-size: 16px;
`

const OptionsContainer = styled.div<{visible: boolean}>`
	position: absolute;
	display: ${props => props.visible ? 'block' : 'none'};
	bottom: ${height}px;
	width: 100%;
	background: rgba(0, 0, 0, 0.8);
	border: 1px solid #eee;
`


const InputContainer = styled.div`
	border: 1px solid #ccc;
	display: grid;
	grid-template-columns: 30px 1fr 30px;
	align-items: center;
	justify-content: center;
`

const Option = styled.div`
	padding: 0.4em 0.75em;
	cursor: pointer;
	display: flex;
	&:hover {
		background: #333;
		
	}
`

const OptionMeta = styled.div`
	opacity: 0.9;
	margin-left: 0.5em;
	font-style: italic;
	font-size: 0.9em;
	color: #999;
`

const SearchInput = styled.input`
	outline: none;
	border: none;
	padding: 0px;
	background: none;
	color: white;
	height: ${height}px;
	line-height: ${height}px;
	font-size: 14px;

`

const EmptyMessage = styled.div`
  padding: 0.5em 0.75em;
	font-style: italic;
`
